import objFetch, {
  fetch
} from './apiConfig'
import qs from 'qs'
import apiList from './api'
import { getCookie } from '../libs/util'
import Vue from '@/main.js'
let baseUrl = ''
if (process.env.NODE_ENV !== 'development') { // 开发环境
  baseUrl = '/neibuliao'
} else { // 线上地址
  // baseUrl = '/neibuliao'
}
const api = {}

apiList.forEach((item, index) => {
  // 默认置为post请求
  item.method = item.method ? item.method : 'post'
  if (item.type === 'url') {
    api[item.name] = baseUrl + item.url
  } else {
    api[item.name] = (params, config) => {
      params.user_id = getCookie('userId') - 0 // 默认每个接口都添加user_id
      let param = ''
      if (config && config.urlParam) { // url拼接参数  config:{urlParam:'参数拼接字符串'}
        param += '/' + config.urlParam
      }
      if (config && config.params) { // get请求方式传参：{}，{params:{get参数}}
        param += '?' + qs.stringify(config.params)
      }
      return fetch(baseUrl + item.url + param, {
        method: item.method,
        headers: (() => {
          let obj = {}
          if (config && config.type && config.type === 'file') {

          } else { // 设置json格式传参  config： {type:'json'}
            obj['Content-Type'] = config && config.type && config.type === 'form' ? 'application/x-www-form-urlencoded' : 'application/json'
          }
          return obj
        })(),
        body: (() => {
          if (config && config.type && config.type === 'file') {
            return params
          } else if (item.method === 'post' && config && config.type && config.type === 'form') {
            return qs.stringify(params)
          } else if (item.method === 'post') {
            return JSON.stringify(params)
          } else {
            return null
          }
        })(),
        credentials: 'include',
        notToJson: !!(config && config.notToJson)
      })
    }
  }
})
// 相应拦截器
objFetch.interceptors_after.push((res, next) => {
  if (res.code === 102) {
    Vue.$router.replace('/login')
  } else {
    next()
  }
})
export {
  api
}
